import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { ServicejobRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/servicejob-remote-action-builder/servicejob-remoteaction-builder';
import { ServicejobRemoteActionType } from 'src/app/_model/remote-action/remote-action-builder/servicejob-remote-action-builder/servicejob-remote-action-type';
import { AppService } from '../../app-service/logic/app.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';
import {
  RequiredUserActionLevel,
  RequiredUserActionValidatorService,
} from '../../user-action-validator/required-user-action-validator.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeOfServicejobActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'cosj';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private servicejobService: ServicejobsService,
    private jobSectionService: JobSectionsService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private appParameterService: AppParameterService,
    private requiredUserActionValidator: RequiredUserActionValidatorService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    if (this.clientStateService.theState.getValue().jobSectionId) {
      const canExecute = await this.requiredUserActionValidator.triggerLevel(
        RequiredUserActionLevel.END_JOBSECTION
      );

      if (!canExecute) {
        return;
      }
    }

    const canExecute = await this.requiredUserActionValidator.triggerLevel(
      RequiredUserActionLevel.END_SERVICEJOB
    );

    if (!canExecute) {
      return;
    }

    this.remoteActionBuilderService.newBuild(
      new ServicejobRemoteActionBuilder(
        ServicejobRemoteActionType.CHANGE_OF_SERVICEJOB,
        this.appService,
        this.credentialsService,
        this.servicejobService,
        this.locationService,
        this.employeeService,
        this.jobSectionService,
        this.clientStateService,
        this.appParameterService,
        this.logger
      )
    );
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
